export const wowAnimation = () => {
  if (typeof window !== "undefined") {
    import("wowjs").then((module) => {
      const WOW = module?.default;
      if (WOW && WOW.WOW) {
        new WOW.WOW({ live: false }).init();
      }
    });
  }
};

export function stripHtmlTags(input: any) {
  if (typeof window === "undefined") {
    // Server-side: Use a regex to strip HTML tags
    return input?.replace(/<\/?[^>]+(>|$)/g, "");
  }
  // Create a temporary DOM element
  const tempDiv = document.createElement("div");
  // Set the innerHTML of the element to the input string
  tempDiv.innerHTML = input;
  // Use the textContent property to extract only the text content
  return tempDiv.textContent || tempDiv.innerText || "";
}

export function hexToRgba(hex: any, alpha = 1) {
  // Remove the hash at the start if it's there
  hex = hex?.replace(/^#/, "");

  // Parse the r, g, b values
  let r, g, b;

  if (hex?.length === 3) {
    // If the hex code is in shorthand form (e.g. #03F)
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex?.length === 6) {
    // If the hex code is in full form (e.g. #0033FF)
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else {
    console.log("Invalid hex color format for RGBA");
  }

  // Return the RGBA string
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const addBeforeStyle = (selector: any, styles: any) => {
  // Create a style element
  const style = document.createElement("style");
  style.type = "text/css";

  // Construct the CSS rule
  const cssRule = `${selector}:hover::before { ${styles} }`;

  // Add the CSS rule to the style element
  // @ts-expect-error
  if (style.styleSheet) {
    // @ts-expect-error
    style.styleSheet.cssText = cssRule; // For IE
  } else {
    style.appendChild(document.createTextNode(cssRule)); // For other browsers
  }

  // Append the style element to the head
  document.head.appendChild(style);
};

export const addStyle = (selector: any, styles: any) => {
  // Create a style element
  const style = document.createElement("style");
  style.type = "text/css";

  // Construct the CSS rule
  const cssRule = `${selector} { ${styles} }`;

  // Add the CSS rule to the style element
  // @ts-expect-error
  if (style.styleSheet) {
    // @ts-expect-error
    style.styleSheet.cssText = cssRule; // For IE
  } else {
    style.appendChild(document.createTextNode(cssRule)); // For other browsers
  }

  // Append the style element to the head
  document.head.appendChild(style);
};

export const darkenHexColor = (hex: string, percent: number) => {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, "");

  // Parse the r, g, b values
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Calculate the new r, g, b values
  r = Math.max(0, Math.min(255, r - (r * percent) / 100));
  g = Math.max(0, Math.min(255, g - (g * percent) / 100));
  b = Math.max(0, Math.min(255, b - (b * percent) / 100));

  // Convert the new r, g, b values back to hex
  const newHex =
    "#" +
    ("0" + Math.round(r).toString(16)).slice(-2) +
    ("0" + Math.round(g).toString(16)).slice(-2) +
    ("0" + Math.round(b).toString(16)).slice(-2);

  return newHex;
};

export function truncate(
  text: string,
  length: number,
  omission: string = "..."
): string {
  if (text.length <= length) {
    return text;
  }
  return text.slice(0, length) + omission;
}

export function get(object: any, path: string, defaultValue: any = undefined) {
  const pathArray = path.split(".");
  let value = object;

  for (const key of pathArray) {
    if (value && typeof value === "object" && key in value) {
      value = value[key];
    } else {
      return defaultValue;
    }
  }

  return value;
}
